import React from 'react';
export function PainSolutionSection() {
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-105">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-106">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-text-main" data-id="element-107">
          Este sistema es para vos si...
        </h2>

        <div className="space-y-3 bg-background rounded-xl p-4 md:p-6 shadow-sm border border-gray-100" data-id="element-108">
          <ul className="space-y-3" data-id="element-109">
            {[<>
                <strong data-id="element-110">Siempre volvés al mismo lugar</strong> sin importar
                cuánto lo intentés — y ya no sabés por qué
              </>, <>
                <strong data-id="element-111">No podés controlar cómo reaccionás</strong> y después te
                sentís culpable por eso
              </>, <>
                Sentís que <strong data-id="element-112">algo no está bien en vos</strong> pero no
                sabés qué es exactamente
              </>].map((text, i) => <li key={i} className="flex items-start gap-2" data-id="element-113">
                <div className="flex-shrink-0 mt-0.5 bg-pain/10 p-0.5 rounded-full" data-id="element-114">
                  <svg className="w-4 h-4 text-pain" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-115">
                    <path d="M18 6 6 18M6 6l12 12" data-id="element-116" />
                  </svg>
                </div>
                <p className="text-sm md:text-base text-text-main leading-snug" data-id="element-117">
                  {text}
                </p>
              </li>)}
          </ul>

          <div className="h-px w-full bg-gray-200" data-id="element-118"></div>

          <div className="flex items-start gap-2" data-id="element-119">
            <div className="flex-shrink-0 mt-0.5 bg-solution/10 p-0.5 rounded-full" data-id="element-120">
              <svg className="w-4 h-4 text-solution" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-121">
                <path d="M20 6 9 17l-5-5" data-id="element-122" />
              </svg>
            </div>
            <p className="text-base md:text-lg font-bold text-text-main leading-snug" data-id="element-123">
              Estás lista para entenderte de verdad, romper los ciclos y empezar
              a elegir diferente
            </p>
          </div>
        </div>

        <a href="https://tulibrodigital.lat/cart/51414367928544:1?checkout" onClick={() => {
        const w = window as any;
        w.fbq && w.fbq('track', 'AddToCart');
      }} className="block w-full text-center bg-accent text-white font-bold text-base py-3 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-124">
          SÍ, ME IDENTIFICO — QUIERO EL SISTEMA
        </a>
      </div>
    </section>;
}